import { DeepReadonly } from '@skylab-shared/types';

const formats = {
    number: {
        groupSeparator: '\u0020',
        decimalSeparator: ',',
        fractionSize: null
    },
    date: {
        dayMonthYear: 'D MMMM YYYY',
        dayMonthYearDateTime: 'D MMMM YYYY H:mm',
        monthYearFormat: 'MMMM YYYY',

        dateTime: 'DD-MM-YYYY - HH:mm:ss',
        dateTimeShort: 'DD-MM-YYYY, HH:mm',

        short: 'DD-MM-YYYY',
        shortDotted: 'D.MM.YYYY',

        webApi: 'YYYY-MM-DD',
        webApiDateTime: 'YYYY-MM-DDTHH:mm:ss.SSS',
        webApiDateTimeWithTimeZone: 'YYYY-MM-DDTHH:mm:ss.SSSZZ'
    }
};

export const DataFormats = <DeepReadonly<typeof formats>> formats;
